(() => {
  const warm = target => {
    const gallery = target?.closest?.('media-gallery');
    if (!gallery) return;
    const slides = [...gallery.querySelectorAll('slideshow-slide')];
    const active = slides.findIndex(slide => slide.getAttribute('aria-hidden') === 'false');
    for (const index of [active, active + 1]) {
      slides[index]?.querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
    }
  };
  document.addEventListener('slideshow:select', event => warm(event.target));
  document.addEventListener('pointerdown', event => warm(event.target), { passive: true });
})();
